/**
 * App Transaction Type
 * Flutter source: lib/domain/enums/app_transaction_type.dart
 *
 * Maps to the transactionType field in Firestore transaction documents.
 * The numeric values must match Flutter exactly (enum index).
 */
export enum AppTransactionType {
  wallet = 0,
  gift = 1,
  subscription = 2,
  unlockContent = 3,
  premiumPackage = 4,
  subscriptionRenewed = 5,
  donation = 6,
  payPremiumVideo = 7,
  payBoostVideo = 8,
}
